import { render, staticRenderFns } from "./skillscompetition.vue?vue&type=template&id=01034a98&scoped=true&"
import script from "./skillscompetition.vue?vue&type=script&lang=js&"
export * from "./skillscompetition.vue?vue&type=script&lang=js&"
import style0 from "./skillscompetition.vue?vue&type=style&index=0&id=01034a98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01034a98",
  null
  
)

export default component.exports